import jhsfBookingsApi from '../apis/jhsfBookingsApi';

const forgotPasswordsService = async (email: string): Promise<void> => {
  await jhsfBookingsApi.post('/passwords/forgot', { email });
};

export default forgotPasswordsService;
